import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// ?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_scrolling_urgency_message_female_fasting~1
			funnel: {
				id: 'ob-scrolling-urgency-message-female-fasting',
				locale: ['en'],
			},
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_scrolling_urgency_message_female_fasting'
					),
			},
		},
	},
]

export default config
